// (function () {
//     'use strict';
//
//     angular
//         .module('ui.modal.module')
//         .controller('ModalInstanceCtrl', ModalInstanceCtrl)
//
//     ModalInstanceCtrl.$inject = ['$uibModal'];
//
//     function ModalInstanceCtrl ($uibModal) {
//         var vm                  = this;
//         vm.animationsEnabled    = true;
//         vm.content              = '';
//         vm.open                 = open();
//         vm.toggleAnimation      = toggleAnimation();
//
//
//         function open (size) {
//                 var modalInstance = $uibModal.open({
//                     animation: vm.animationsEnabled,
//                     templateUrl: 'myModalContent.html',
//                     controller: 'ModalInstanceCtrl',
//                     size: size,
//                     resolve: {
//                         items: function () {
//                             return vm.items;
//                         }
//                     }
//                 });
//
//                 modalInstance.result.then(function (selectedItem) {
//                     vm.selected = selectedItem;
//                 }, function () {
//                     $log.info('Modal dismissed at: ' + new Date());
//                 });
//             };
//         }
//
//         function toggleAnimation () {
//             vm.animationsEnabled = !vm.animationsEnabled;
//         }
//
//
// })();